var map = {
	"./banner.png": "ec24",
	"./bg.png": "d68e",
	"./curtain.png": "8980",
	"./empty/error.png": "9a9c",
	"./empty/mt-empty.png": "dc56",
	"./empty/normal.png": "cd42",
	"./empty/search.png": "71ec",
	"./icon-link.png": "1c07",
	"./light-off.png": "865f",
	"./light-on.png": "57ce",
	"./logo.png": "cf05",
	"./logo2.png": "5fbe",
	"./picture-outline.png": "fd9d",
	"./tencentMt.png": "8964",
	"./workchat.png": "253a",
	"./xyLink.png": "c9fa",
	"./zoomLogo.png": "4bbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";